
import React, { useState } from "react";
import { motion } from "framer-motion";
import ProductDetailsPopup from "./Productdetailspopup";
import { getImageUrl } from "../../utils/helper";
import AnalyticsService from "services/analytics.service";
import { EVENT_NAME } from "utils/constants";
import { MdOutlineInfo } from "react-icons/md";
import { TimeUtils } from "utils/time.utils";


const ProductCard = ({
  product,
  commonProductList = [],
  onProductChange,
  cart,
  clearFromCart,
  setCart,
  isRepairPage = false,
}) => {
  const [showPriceTooltip, setShowPriceTooltip] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  
  // Determine if the shop is open
  const isOpen = !(product.merchant?.isShopClosed || false);

  const handleAddToCart = (product, selectedShop) => {
    if (!isOpen) return; // Prevent adding to cart if shop closed
    
    setCart((prevCart) => ({
      ...prevCart,
      [product.id]: {
        ...product,
        quantity: product.minQuantity || 1,
      },
    }));
    AnalyticsService.trackEvent(EVENT_NAME.CART_PRODUCT_ADDED, {
      productId: product.id,
      productName: product.name,
      minQuantity: product.minQuantity || 1,
      merchantId: product.merchantId,
      merchantName: product.merchant?.displayName,
      categoryId: product.categoryId,
    });
  };

  const handleIncreaseQuantity = (product) => {
    setCart((prevCart) => ({
      ...prevCart,
      [product.id]: {
        ...prevCart[product.id],
        quantity: prevCart[product.id].quantity + 1,
      },
    }));
    AnalyticsService.trackEvent(EVENT_NAME.CART_PRODUCT_QUANTITY_INCREASED, {
      productId: product.id,
      productName: product.name,
      merchantName: product.merchant?.displayName,
    });
  };

  const handleDecreaseQuantity = (product) => {
    setCart((prevCart) => {
      const updatedCart = { ...prevCart };
      const existingProduct = prevCart[product.id];

      // Prevent quantity from going below minQuantity
      if (existingProduct.quantity > (product.minQuantity || 1)) {
        updatedCart[product.id].quantity -= 1;
      } else {
        delete updatedCart[product.id];
      }

      return updatedCart;
    });
    AnalyticsService.trackEvent(EVENT_NAME.CART_PRODUCT_QUANTITY_DECREASED, {
      productId: product.id,
      productName: product.name,
      merchantName: product.merchant?.displayName,
      merchantId: product.merchantId,
    });
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          style={{
            color: i <= rating ? "#ffc107" : "#e4e5e9",
            fontSize: "20px",
            marginRight: "2px",
          }}
        >
          {i <= rating ? "★" : "☆"}
        </span>
      );
    }
    return stars;
  };

  return (
    <>
      <motion.div
        className={`product-card ${!isOpen ? 'shop-closed' : ''}`}
        key={product.id}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <img
          src={getImageUrl(product.imageUrl)}
          alt={product.name}
          className="product-image"
          onClick={() => setIsPopupOpen(true)}
        />
        <div className="product-info" style={{ textAlign: "left" }}>
          <h2 className="product-name">{product.name}</h2>
          {product.rating && (
            <div style={{ marginBottom: "10px" }}>
              {renderStars(product.rating)}
            </div>
          )}
          
          {/* Shop closed message */}
          {!isOpen && (
            <div className="shop-closed-message">
              Shop is closed for now { product.merchant?.openTime ? `(Opens at ${TimeUtils.dbTimeColumnToDate(product.merchant?.openTime)})` : ''}
            </div>
          )}
          
          {!isRepairPage && product.merchant && (
            <div>
              Shop: <b>{product.merchant?.displayName}</b>
            </div>
          )}
          {product.isPriceBasedOnLocation ? (
            <p>
              <b>Fees</b>: लोकेशन के हिसाब से
            </p>
          ) : (
            <p className="product-price">
              {product.sellingPrice !== product.listingPrice && (
                <span className="original-price">
                  ₹{cart[product.id]?.price || product.listingPrice}
                </span>
              )}
              <span className="final-price">
                ₹{cart[product.id]?.FinalPrice || product.sellingPrice}
                <span
                  className="price-info-icon"
                  onMouseEnter={() => setShowPriceTooltip(true)}
                  onMouseLeave={() => setShowPriceTooltip(false)}
                >
                  <MdOutlineInfo size={10} style={{ marginLeft: '3px', marginTop: "10px", color: '#e2542c' }} />
                  {showPriceTooltip && (
                    <div className="price-tooltip">
                      <ul>
                        <li>Platform fee is included with the price</li>
                        <li>MRP may be lower than actual shop price</li>
                      </ul>
                    </div>
                  )}
                </span>
              </span>
            </p>
          )}
          {product.minQuantity > 1 && (
            <p style={{ color: "red" }} className="min_order_quantity_text">
              Min Order Quantity: {product.minQuantity}
            </p>
          )}
          {commonProductList.length > 0 && (
            <div className="shop-selection">
              <span style={{ cursor: "pointer", color: "red", fontSize: "16px" }}>
                <div>change shop</div>
              </span>
              <select
                value={product.id}
                onChange={(e) => onProductChange(e.target.value)}
                className="product-actions-dropdown"
              >
                {commonProductList.map((commonProduct) => (
                  <option key={commonProduct.id} value={commonProduct.id}>
                    {commonProduct.merchant.displayName} - ₹{commonProduct.sellingPrice}
                  </option>
                ))}
              </select>
            </div>
          )}
          {cart[product.id] ? (
            <div className="quantity-control">
              {!isRepairPage && (
                <>
                  <motion.button
                    className="quantity-btn decrease-btn"
                    onClick={() => handleDecreaseQuantity(product)}
                  >
                    -
                  </motion.button>
                  <span className="quantity">{cart[product.id]?.quantity}</span>
                  <motion.button
                    className="quantity-btn increase-btn"
                    onClick={() => handleIncreaseQuantity(product)}
                  >
                    +
                  </motion.button>
                </>
              )}
              <motion.button
                className="remove-btn"
                onClick={() => clearFromCart(product.id)}
              >
                Remove
              </motion.button>
            </div>
          ) : (
            <motion.button
              className={`add-to-cart-btn ${!isOpen ? 'disabled-btn' : ''}`}
              onClick={() => handleAddToCart(product, product.merchant)}
              disabled={!isOpen}
            >
              {!isOpen 
                ? "Shop Closed" 
                : (isRepairPage ? "Book a Service" : "Add to Cart")
              }
            </motion.button>
          )}
        </div>
      </motion.div>

      {/* {isPopupOpen && (
        <ProductDetailsPopup
          product={product}
          cart={cart}
          handleAddToCart={handleAddToCart}
          handleShopChange={() => { }}
          handleIncreaseQuantity={handleIncreaseQuantity}
          handleDecreaseQuantity={handleDecreaseQuantity}
          clearFromCart={clearFromCart}
          isRepairPage={isRepairPage}
          isShopOpen={isOpen}
          onClose={() => setIsPopupOpen(false)}
        />
      )} */}
    </>
  );
};

export default ProductCard;